module.exports = {
	custom110: 'rgb(242, 139, 0)',
	custom100: 'rgb(225, 93, 118)',
	custom111: 'rgb(242, 139, 0)',
	custom1: 'rgb(255, 123, 132)',
	custom101: 'rgb(242, 139, 0)',
	custom112: 'rgb(242, 139, 0)',
	custom2: 'rgb(207, 208, 92)',
	custom102: 'rgb(242, 139, 0)',
	custom113: 'rgb(242, 139, 0)',
	custom90: 'rgb(34, 164, 138)',
	custom3: 'rgb(236, 180, 108)',
	custom103: 'rgb(242, 139, 0)',
	custom80: 'rgb(101, 154, 213)',
	custom91: 'rgb(191, 123, 102)',
	custom4: 'rgb(225, 217, 81)',
	custom104: 'rgb(242, 139, 0)',
	custom70: 'rgb(231, 105, 180)',
	custom81: 'rgb(218, 98, 127)',
	custom92: 'rgb(81, 126, 130)',
	custom5: 'rgb(159, 219, 102)',
	custom105: 'rgb(242, 139, 0)',
	custom60: 'rgb(191, 90, 136)',
	custom71: 'rgb(227, 110, 227)',
	custom82: 'rgb(209, 91, 151)',
	custom93: 'rgb(144, 77, 76)',
	custom6: 'rgb(84, 196, 115)',
	custom106: 'rgb(242, 139, 0)',
	custom50: 'rgb(73, 188, 211)',
	custom61: 'rgb(245, 115, 118)',
	custom72: 'rgb(141, 155, 251)',
	custom83: 'rgb(231, 128, 111)',
	custom94: 'rgb(67, 156, 186)',
	custom7: 'rgb(106, 137, 229)',
	custom107: 'rgb(242, 139, 0)',
	custom40: 'rgb(131, 199, 94)',
	custom51: 'rgb(216, 199, 96)',
	custom62: 'rgb(107, 146, 220)',
	custom73: 'rgb(103, 158, 240)',
	custom84: 'rgb(246, 112, 123)',
	custom95: 'rgb(139, 207, 106)',
	custom8: 'rgb(80, 206, 185)',
	custom108: 'rgb(242, 139, 0)',
	custom30: 'rgb(245, 159, 113)',
	custom41: 'rgb(67, 181, 181)',
	custom52: 'rgb(238, 142, 111)',
	custom63: 'rgb(124, 207, 96)',
	custom74: 'rgb(65, 200, 160)',
	custom85: 'rgb(242, 104, 145)',
	custom96: 'rgb(109, 157, 227)',
	custom9: 'rgb(107, 158, 226)',
	custom109: 'rgb(242, 139, 0)',
	custom20: 'rgb(72, 199, 200)',
	custom31: 'rgb(235, 104, 127)',
	custom42: 'rgb(207, 208, 91)',
	custom53: 'rgb(243, 110, 131)',
	custom64: 'rgb(97, 143, 216)',
	custom75: 'rgb(205, 159, 101)',
	custom86: 'rgb(226, 96, 171)',
	custom97: 'rgb(221, 96, 133)',
	custom10: 'rgb(100, 136, 227)',
	custom21: 'rgb(138, 122, 237)',
	custom32: 'rgb(56, 195, 147)',
	custom43: 'rgb(127, 147, 249)',
	custom54: 'rgb(234, 112, 177)',
	custom65: 'rgb(242, 121, 171)',
	custom76: 'rgb(219, 109, 122)',
	custom87: 'rgb(216, 118, 229)',
	custom98: 'rgb(225, 190, 92)',
	custom11: 'rgb(135, 132, 234)',
	custom22: 'rgb(139, 133, 249)',
	custom33: 'rgb(151, 207, 93)',
	custom44: 'rgb(200, 202, 88)',
	custom55: 'rgb(214, 110, 224)',
	custom66: 'rgb(216, 190, 95)',
	custom77: 'rgb(181, 93, 91)',
	custom88: 'rgb(153, 111, 230)',
	custom99: 'rgb(240, 133, 110)',
	custom12: 'rgb(220, 113, 209)',
	custom23: 'rgb(176, 112, 230)',
	custom34: 'rgb(213, 138, 106)',
	custom45: 'rgb(217, 88, 121)',
	custom56: 'rgb(113, 141, 235)',
	custom67: 'rgb(248, 125, 118)',
	custom78: 'rgb(90, 149, 221)',
	custom89: 'rgb(62, 153, 190)',
	custom13: 'rgb(223, 97, 132)',
	custom24: 'rgb(229, 103, 152)',
	custom35: 'rgb(233, 99, 126)',
	custom46: 'rgb(103, 165, 231)',
	custom57: 'rgb(90, 156, 221)',
	custom68: 'rgb(242, 105, 121)',
	custom79: 'rgb(142, 211, 99)',
	custom14: 'rgb(60, 194, 179)',
	custom25: 'rgb(228, 111, 190)',
	custom36: 'rgb(212, 114, 212)',
	custom47: 'rgb(95, 204, 100)',
	custom58: 'rgb(52, 181, 157)',
	custom69: 'rgb(237, 99, 135)',
	custom15: 'rgb(247, 126, 117)',
	custom26: 'rgb(118, 152, 240)',
	custom37: 'rgb(140, 137, 242)',
	custom48: 'rgb(239, 105, 127)',
	custom59: 'rgb(227, 208, 103)',
	custom16: 'rgb(233, 175, 103)',
	custom27: 'rgb(90, 176, 210)',
	custom38: 'rgb(83, 182, 215)',
	custom49: 'rgb(226, 92, 128)',
	custom17: 'rgb(172, 211, 96)',
	custom28: 'rgb(137, 192, 89)',
	custom39: 'rgb(79, 190, 117)',
	custom18: 'rgb(77, 202, 118)',
	custom29: 'rgb(189, 210, 95)',
	custom19: 'rgb(58, 190, 177)',
};
